

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { ROEWeb } from "../../components/ROEWeb";


export const ROEWebPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="ROE Web"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<ROEWeb />}
    />
  );
};
